import React from "react"
// import menu from '../scripts/menu.js';
import '../styles/index.scss';
import '../styles/utils.scss';
import anchorLinkJump from '../scripts/anchor-link-jump.js'; 


import Button from '../components/Button';
import Client from '../components/Client';
import Footer from '../components/Footer';
import Form from '../components/Form';
import HalfHero from '../components/HalfHero';
import Header from '../components/Header';
import Hero from '../components/Hero';
import IconList from '../components/IconList';
import Testimonial from '../components/Testimonial';
import Testimonials from '../components/Testimonials';


export default ({children}) => 
  <div className={'global-wrapper'}>
    <Header />
    {children()}
    <Form>
      <h2>Get Started Today!</h2>
      <p>Fill out this short form to start your personalized transformation!</p>
    </Form>
    <Footer />
    { anchorLinkJump() }
  </div>



// WEBPACK FOOTER //
// ./src/layouts/index.js